// removed by extract-text-webpack-plugin
module.exports = {"gameEventTabsContainer":"J9qDTY0JTV_puatQkrH81","gameEventTabs":"_1VA6t7v7MNvlnXsaWBE2PB","resultContainer":"_1lal8gP8iQixXSrvEw-jbU","matchdayEventTabContainer":"_2X6opI1Cbe8VRwTptsvKLx","loading":"oEOPfMgaT0xpZ3k8QbZbt","blink":"_1-C1wHHRFaMpNFyWYV4JOP"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/css/gameEventTabs.css
// module id = 684
// module chunks = 0